// extracted by mini-css-extract-plugin
export default {"_":"notificate____Y4T2-","fon":"notificate_fon__YzIPB"};